export default __webpack_public_path__ + "static/media/roboto-v30-latin-regular.b009a76a.woff2";